import differenceInSeconds from 'date-fns/differenceInSeconds';
import {useCallback, useEffect, useState} from 'react';
import {getDateDifference} from '../../../../common/shared/utils/getDateDifference';
import useTypedDispatch from '../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../common/useTypedSelector';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {setNoticeNewDot} from '../state/contentHomeSlice';

export function useContentHomeLastNotice(seriesId: number) {
  const lastNoticeDateStr = useContentHomeOverviewQuery(
    {seriesId},
    ONLY_DATA_CONFIG
  ).data?.contentHomeOverview?.lastNoticeDate;
  const newDot = useTypedSelector(
    state => state.contentHome.noticeNewDot[seriesId]
  );
  const dispatch = useTypedDispatch();
  const [isUpdated, setIsUpdated] = useState(false);

  useEffect(() => {
    if (newDot !== undefined) {
      setIsUpdated(newDot);
    }
  }, [newDot]);

  useEffect(() => {
    if (!lastNoticeDateStr) {
      return;
    }

    const lastNoticeDate = new Date(lastNoticeDateStr);
    const differenceWithNow = getDateDifference({
      dateLeft: new Date(),
      dateRight: lastNoticeDate,
    });
    if (differenceWithNow.days >= 7) {
      return;
    }

    const contentHomeMapStr = window.localStorage.getItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_NOTICE_LAST_VISIT
    );

    const contentHomeMap: ContentHomeLastVisitMap = contentHomeMapStr
      ? JSON.parse(contentHomeMapStr)
      : {};
    const lastVisitDate = contentHomeMap[seriesId]
      ? new Date(contentHomeMap[seriesId])
      : undefined;
    if (lastVisitDate) {
      const difference = differenceInSeconds(lastVisitDate, lastNoticeDate);
      if (difference >= 0) {
        return;
      }
    }
    setIsUpdated(true);
  }, [lastNoticeDateStr, seriesId]);

  const visit = useCallback(() => {
    const contentHomeMapStr = window.localStorage.getItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_NOTICE_LAST_VISIT
    );
    const contentHomeMap: ContentHomeLastVisitMap = contentHomeMapStr
      ? JSON.parse(contentHomeMapStr)
      : {};
    contentHomeMap[seriesId] = new Date().getTime();
    window.localStorage.setItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_NOTICE_LAST_VISIT,
      JSON.stringify(contentHomeMap)
    );
    dispatch(setNoticeNewDot({seriesId, newDot: false}));
  }, [dispatch, seriesId]);

  return {
    isUpdated,
    visit,
  };
}

export interface ContentHomeLastVisitMap {
  [key: /* seriesId */ number]: number;
}

export const LOCAL_STORAGE_KEY_CONTENT_HOME_NOTICE_LAST_VISIT = 'CHNLV';
